import { CheckPointInfoView } from "../views/chekPointInfoView";
import { useParams } from "react-router-dom";
import locationInfo from "../data/locationInfo.json";
import travelData from "../data/travelInfoData.json"
import images from "../images/images.js";


function CheckPointInfo() {
  const { id } = useParams();
  const location = id && locationInfo ? locationInfo[id] : null;
  const imageKey = images[`picture_${id}`];
  const infoData = travelData[id]


  function backtoMapACB() {
    window.location.hash = "#/mapOverview";
  }

  return (
    <CheckPointInfoView
      location={location}
      onBack={backtoMapACB}
      imageKey={imageKey}
      infoData={infoData}
    />
  );
}

export { CheckPointInfo };
